"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkACL = checkACL;
exports.getResourceDisplayKey = getResourceDisplayKey;
exports.getActionDisplayKey = getActionDisplayKey;
exports.getResourceEnumValue = getResourceEnumValue;
exports.getActionEnumValue = getActionEnumValue;
const resources_1 = require("../../app/acl_module/config/resources");
const actions_1 = require("../../app/acl_module/config/actions");
function checkACL(aclString, aclPolicy) {
    if (!aclPolicy) {
        return false;
    }
    let [resourceKey, actionKey] = aclString.split('.');
    if (!resourceKey || !actionKey) {
        console.error(`Invalid ACL string format: ${aclString}. Expected format: "resource.action"`);
        return false;
    }
    // Convert to enum values if they're display keys
    let resourceEnum;
    let actionEnum;
    // If resourceKey starts with 'res_', it's already an enum value
    if (resourceKey.startsWith('res_')) {
        resourceEnum = resourceKey;
    }
    else {
        // It's a display key, convert to enum value
        resourceEnum = getResourceEnumValue(resourceKey) || resourceKey;
    }
    // If actionKey starts with 'role_', it's already an enum value
    if (actionKey.startsWith('role_')) {
        actionEnum = actionKey;
    }
    else {
        // It's a display key, convert to enum value
        actionEnum = getActionEnumValue(actionKey) || actionKey;
    }
    // Check if user has the required permission using enum values
    const userResourcePermissions = aclPolicy[resourceEnum];
    const result = userResourcePermissions && userResourcePermissions.includes(actionEnum);
    return result;
}
// Helper functions to convert enum values to display keys
function getResourceDisplayKey(enumValue) {
    // Dynamically find the key name from the aclResources enum
    const resourceKey = Object.keys(resources_1.aclResources).find(key => resources_1.aclResources[key] === enumValue);
    return resourceKey || enumValue.replace('res_', '');
}
function getActionDisplayKey(enumValue) {
    // Dynamically find the key name from the aclActions enum
    const actionKey = Object.keys(actions_1.aclActions).find(key => actions_1.aclActions[key] === enumValue);
    return actionKey || enumValue.replace('role_', '');
}
// Helper functions to convert keys to enum values
function getResourceEnumValue(key) {
    // Get the enum value from the resource key
    const enumValue = resources_1.aclResources[key];
    return enumValue || null;
}
function getActionEnumValue(key) {
    // Get the enum value from the action key
    const enumValue = actions_1.aclActions[key];
    return enumValue || null;
}
